import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowAltCircleLeft, faArrowCircleLeft, faArrowCircleRight, faBan, faEllipsisV, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { EditIcon } from '../../../../design/static/icons/EditIcon';
import { AnnotationNavigationButton } from '../../../../modules/common/annotationNavigationButton/AnnotationNavigationButton';
import { EditorMode } from '../../../../modules/editor/models/EditorModes';
import { ValidSaveIcon } from '../../../components/icons/ValidSaveIcon';
import { RequestClarificationButtonContainer } from '../submodules/clarifications/containers/RequestClarificationButton.container';
import { DiscardAnnotationConfirmationModal } from './DiscardAnnotationConfirmationModal';

library.add(faArrowCircleRight, faTimesCircle, faArrowCircleLeft, faBan, faArrowAltCircleLeft, faEllipsisV);

interface IProps {
  onAccept: () => Promise<void>;
  onReject: () => Promise<void>;
  onEdit: () => Promise<void>;
  onDiscard: () => void;
  onDiscardConfirmed: () => Promise<void>;
  onDiscardCanceled: () => void;
  onCancel: () => Promise<void>;
  disabled: boolean;
  canDiscard: boolean;
  showDiscardModal: boolean;
  canCancel: boolean;
  editorMode: EditorMode;
}

export const ReviewNavigation = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <div className='annotation-navigation review'>
      <AnnotationNavigationButton
        size='md'
        id='accept-annotation'
        loaderKey='accept-button'
        disabled={props.disabled}
        onClick={props.onAccept}
        title={t('review_accept_tooltip')}
        startDecorator={<ValidSaveIcon />}
      >
        {t('accept')}
      </AnnotationNavigationButton>
      <AnnotationNavigationButton
        size='md'
        color='danger'
        loaderKey='reject-button'
        disabled={props.disabled}
        onClick={props.onReject}
        title={t('reject_tooltip')}
        startDecorator={<FontAwesomeIcon icon={faTimesCircle} />}
      >
        {t('reject')}
      </AnnotationNavigationButton>
      {props.canDiscard && (
        <AnnotationNavigationButton
          size='md'
          color='neutral'
          variant='outlined'
          id='discard-annotation'
          loaderKey='discard-annotation-button'
          disabled={props.disabled}
          onClick={props.onDiscard}
          title={t('discard_tooltip')}
          startDecorator={<FontAwesomeIcon icon={faBan} />}
        >
          {t('discard')}
        </AnnotationNavigationButton>
      )}
      <RequestClarificationButtonContainer
        disabled={props.disabled}
        editorMode={props.editorMode}
      />
      <DiscardAnnotationConfirmationModal
        showDiscardModal={props.showDiscardModal}
        onDiscardCancel={props.onDiscardCanceled}
        onDiscardConfirm={props.onDiscardConfirmed}
      />
      <AnnotationNavigationButton
        size='md'
        color='neutral'
        variant='outlined'
        loaderKey=''
        disabled={props.disabled}
        onClick={props.onEdit}
        title={t('correct_tooltip')}
        startDecorator={<EditIcon className='edit-icon' />}
      >
        {t('fix')}
      </AnnotationNavigationButton>

      {props.canCancel && (
        <AnnotationNavigationButton
          size='md'
          loaderKey='cancel-annotation-button'
          disabled={props.disabled}
          onClick={props.onCancel}
          title={t('cancel_tooltip')}
          startDecorator={<FontAwesomeIcon icon={faArrowAltCircleLeft} />}
          color='neutral'
          variant='outlined'
        >
          {t('cancel')}
        </AnnotationNavigationButton>
      )}
    </div>
  );
});
